import React from "react";

// BrownStone Jazz Club Logo - Treble Clef S
const TrebleClefLogo = ({ className = "", size = 32 }) => {
  return (
    <span
      className={`text-electric inline-flex items-center justify-center ${className}`}
      style={{ 
        fontSize: size,
        lineHeight: 1,
        transform: 'scaleX(-1.3)',
        fontFamily: 'serif'
      }}
      aria-label="BrownStone Jazz Club"
    >
      𝄞
    </span>
  );
};

// Simple inline version for smaller uses - supports responsive className
export const TrebleClefIcon = ({ className = "", size }) => (
  <span
    className={`text-electric inline-flex items-center justify-center ${className}`}
    style={{ 
      ...(size ? { fontSize: size } : {}),
      lineHeight: 1,
      transform: 'scaleX(-1.3)',
      fontFamily: 'serif'
    }}
    aria-label="BrownStone"
  >
    𝄞
  </span>
);

export default TrebleClefLogo;
